/**
 * Filter-aware Buying guide + FAQ for CodeSkin shop collection.
 */
(function () {
  var FAQ = {
    all: [
      [
        'Which CodeSkin sunscreen is best for oily Indian skin?',
        "UltraProtect Fluid Sunscreen (SPF 50+ PA++++) has a matte, invisible finish that suits oily and acne-prone skin in Indian climates. Pair it with <a href='#' data-codeskin-guide-link='faceWashOily'>FaceWash OILY</a> for a sebum-controlling routine.",
      ],
      [
        "What's the difference between BRITE, CLARIFI and OILY face washes?",
        '<strong>BRITE</strong> uses AHA · BHA · PHA + azelaic acid for dullness and uneven tone. <strong>CLARIFI</strong> uses colloidal sulfur + panthenol for acne-prone skin. <strong>OILY</strong> uses salicylic acid + zinc PCA for sebum control.',
      ],
      [
        'Is CodeSkin safe for sensitive skin and pregnancy?',
        "Every formula is dermatologist patch-tested and free of our 60+ no-go ingredients. Pregnancy: avoid retinoid-based serums; stick to gentle cleansers, <a href='#' data-codeskin-guide-link='haSerum'>hyaluronic acid serums</a> and mineral SPF. Always confirm with your doctor.",
      ],
      [
        'Where are CodeSkin products manufactured?',
        'All formulas are developed and produced in-house at our GMP-certified <strong>Effeza Science Lab in Mumbai</strong>, under founder Oscar Pereira.',
      ],
      [
        'How do I build a routine using CodeSkin?',
        "Take the free <a href='#' data-codeskin-guide-link='aiScan'>AI Skin Scan</a> - upload a selfie and get a 4-step routine personalised to your skin type, concerns and climate.",
      ],
      [
        'Do you ship across India and offer returns?',
        'Yes - free shipping over <strong>₹499</strong>, easy <strong>14-day returns</strong>. UPI, Paytm and major cards accepted.',
      ],
    ],
    sunscreen: [
      [
        'What SPF should I be using in Indian sun?',
        'For daily India use we recommend a broad-spectrum <strong>SPF 50+ PA++++</strong>. UltraProtect and UltraMineral Glo are both SPF 50+; UltraLite is SPF 40+ for indoor-heavy days or sensitive skin.',
      ],
      [
        'UltraProtect vs UltraLite vs UltraMineral Glo - which one for me?',
        '<strong>UltraProtect</strong> (SPF 50+) - matte, invisible, for oily / acne-prone. <strong>UltraLite</strong> (SPF 40+) - featherlight, for everyday wear and sensitive skin. <strong>UltraMineral Glo</strong> (SPF 50, mineral) - radiance finish for dry / dull skin and pregnancy-safe routines.',
      ],
      [
        'Is mineral or chemical sunscreen better for sensitive skin?',
        'Mineral filters (zinc oxide, titanium dioxide) sit on the skin and are usually better tolerated by sensitive / reactive skin and during pregnancy. UltraMineral Glo is fully mineral; UltraProtect and UltraLite use modern photostable filters.',
      ],
      [
        'How often should I reapply sunscreen?',
        'Every 2-3 hours during outdoor exposure, and after sweating or swimming. For desk-based days, one solid morning application is usually enough - but reapply if you step out at lunch.',
      ],
      [
        "Can sunscreen replace a day cream?",
        "Yes, if it's hydrating enough. UltraLite has Niacinamide + prebiotics that double as light skincare. For very dry skin, layer UltraIntense Moisturizer underneath.",
      ],
    ],
    facewash: [
      [
        'How many times a day should I wash my face?',
        'Twice - morning and night. In humid Indian summers you can add a midday rinse with water alone. Over-washing strips the barrier and triggers more oil.',
      ],
      [
        'BRITE vs CLARIFI vs OILY vs SENSI - which CodeSkin face wash?',
        '<strong>BRITE</strong> - daily brightening, AHA · BHA · PHA. <strong>CLARIFI</strong> - acne-prone, colloidal sulfur + azelaic acid. <strong>OILY</strong> - sebum control, salicylic + zinc PCA. <strong>SENSI</strong> - calming, centella + allantoin.',
      ],
      [
        'Can I use an acid-based face wash every day?',
        "Yes - CodeSkin cleansers use low-percentage, rinse-off acids that condition the skin without leaving residue. Start with PM only if you're new to actives; add AM after 1-2 weeks.",
      ],
      [
        'Should I double cleanse in India?',
        'If you wear sunscreen, makeup or heavy moisturizer - yes, at night. Start with a pre-cleanser (oil / micellar), then a water-based wash to fully reset the skin.',
      ],
    ],
    serum: [
      [
        'Niacinamide vs Hyaluronic vs Vitamin C - which comes first?',
        "Water-based serums first (<a href='#' data-codeskin-guide-link='haSerum'>Hyaluronic 7+</a>), then actives (DarkSpot, Anti-Ageing), then oil-based last. Vitamin C / niacinamide go in the AM under sunscreen; retinoids strictly PM.",
      ],
      [
        'When will I see results from a CodeSkin serum?',
        'Hydration / glow: within 1-2 weeks. Brightening / pigmentation: 6-8 weeks. Firming / anti-ageing: 8-12 weeks of consistent use. Always pair with daily SPF.',
      ],
      [
        'Can I layer multiple serums together?',
        'Up to two. Best pairings: Hyaluronic 7+ with any active; Niacinamide with DarkSpot; Peptides (VitaFirm) with Hyaluronic. Avoid stacking acids on the same night.',
      ],
      [
        'Which serum is best for dehydrated, dull skin?',
        "Hyaluronic 7+ Serum - 7 molecular weights of HA + polyglutamic acid. Pair with UltraIntense Moisturizer at night to lock it in.",
      ],
    ],
    moisturizer: [
      [
        'Do oily skin types really need a moisturizer?',
        'Yes - skipping moisturizer triggers more oil production. Use a gel-light one (e.g. Barrier Moisturizer) at night, and let UltraProtect or UltraLite double up in the morning.',
      ],
      [
        'When should I use UltraIntense vs a regular moisturizer?',
        'UltraIntense is a barrier-repair cream for compromised skin (active retinoids, acid users, post-procedure, dry winters). For everyday use on normal/combination skin, a lighter formula is enough.',
      ],
      [
        'Day cream or night cream - do I need both?',
        'Not necessarily. One good moisturizer used AM and PM is fine for most people. Add a richer night cream only if your skin feels tight in the morning.',
      ],
    ],
    'pre-cleanser': [
      [
        'What is a pre-cleanser and do I need one?',
        'A first-step oil or micellar cleanse used at night to dissolve sunscreen, sebum and makeup before your regular face wash. Essential if you wear daily SPF or makeup.',
      ],
      [
        'Will a pre-cleanser break me out?',
        'Not if formulated right. CodeSkin pre-cleansers are non-comedogenic and emulsify fully when rinsed - they leave no oily residue.',
      ],
    ],
    targeted: [
      [
        'What counts as a targeted treatment?',
        'Concentrated spot or zone treatments for specific concerns - acne marks, melasma patches, fine lines, redness flare-ups. Use after serum, before moisturizer, on affected areas only.',
      ],
      [
        'Can I layer two targeted treatments?',
        'Generally one per night unless your dermatologist advises otherwise. Targeted formulas are potent - too much at once compromises the barrier.',
      ],
    ],
    acne: [
      [
        'Which CodeSkin products are best for acne?',
        'Core routine: <strong>FaceWash CLARIFI</strong> (or OILY), Hyaluronic 7+ Serum AM, a non-comedogenic moisturizer, and <strong>UltraProtect SPF 50+</strong>. Add CLARIFI spot treatments at night on active breakouts.',
      ],
      [
        'Should I avoid moisturizer if I have acne?',
        'No - dehydrated skin overproduces oil and makes acne worse. Use a lightweight, non-comedogenic moisturizer like Barrier Moisturizer.',
      ],
      [
        'What ingredients fade post-acne marks and PIH?',
        "Niacinamide, Tranexamic Acid, Cysteamine HCl and Azelaic Acid. CodeSkin's <strong>DarkSpot Correcting Day Serum</strong> uses all four.",
      ],
      [
        'How long until acne products start working?',
        'Active breakouts: 2-4 weeks. Texture and pores: 6-8 weeks. Post-acne marks: 8-12 weeks. Daily SPF is non-negotiable or marks darken further.',
      ],
    ],
    sensitivity: [
      [
        'My skin reacts to everything - where do I start?',
        'Pare back to FaceWash SENSI, Hyaluronic 7+, a fragrance-free moisturizer and UltraMineral Glo (mineral SPF). Add one new product at a time, every 2 weeks.',
      ],
      [
        'Which CodeSkin formulas are fragrance-free?',
        'SENSI cleanser, Hyaluronic 7+, UltraMineral Glo and Barrier Moisturizer are formulated without added fragrance and patch-tested on reactive skin.',
      ],
      [
        'Can I use actives on sensitive skin?',
        "Yes, gently. Start with one PM-only active 2�- per week (e.g. azelaic acid). Build to 3-4�- per week if your skin tolerates it. Always patch-test 48 hrs first.",
      ],
    ],
    pigmentation: [
      [
        'Best CodeSkin routine for pigmentation and uneven tone?',
        '<strong>FaceWash BRITE</strong> AM/PM, <strong>DarkSpot Correcting Day Serum</strong> AM, a barrier moisturizer, and <strong>UltraProtect SPF 50+ PA++++</strong> reapplied every 2-3 hrs.',
      ],
      [
        'How long does pigmentation take to fade?',
        'Surface PIH: 4-8 weeks. Melasma and deeper sun damage: 12-16+ weeks. SPF is the single biggest factor - without it nothing else works.',
      ],
      [
        "Tranexamic acid vs cysteamine vs niacinamide - what's the difference?",
        'Niacinamide blocks pigment transfer (gentle, daily). Tranexamic acid calms inflammation-driven pigment (great for melasma). Cysteamine is the strongest option for stubborn marks. DarkSpot Serum combines all three.',
      ],
    ],
    darkspots: [
      [
        'Best CodeSkin serum for dark spots and melasma?',
        '<strong>DarkSpot Correcting Day Serum</strong> - Cysteamine HCl + Tranexamic Acid + Niacinamide. Use daily under SPF 50+ for 8-12 weeks for visible reduction.',
      ],
      [
        'Can I use DarkSpot serum during the day?',
        "Yes, it's specifically formulated for daytime use and pairs with any sunscreen. Strict daily SPF is required - sun exposure undoes results.",
      ],
      [
        'Will melasma come back?',
        "Melasma is hormonal and chronic - it's managed, not cured. Maintain results with daily SPF, antioxidant serum and pigment-correcting actives 2-3�- per week.",
      ],
    ],
    antiageing: [
      [
        'When should I start anti-ageing skincare?',
        'Mid-20s is reasonable for antioxidant + SPF habits. Active retinoids and peptides are most useful from late 20s onwards. Start gentle, build tolerance.',
      ],
      [
        'Retinol vs peptides - which is right for me?',
        '<strong>Retinol</strong> (Anti-Ageing Night Serum) - gold-standard for lines, texture and elasticity. <strong>Peptides</strong> (VitaFirm) - gentler, firming, no irritation. Many use both: peptides AM, retinol PM.',
      ],
      [
        'Can I use anti-ageing serums on sensitive skin?',
        'Yes - start with VitaFirm peptide gel 4-5 nights a week, build slowly to retinoids. Always pair with a barrier moisturizer.',
      ],
    ],
    dryness: [
      [
        "What's the best CodeSkin routine for dry skin?",
        '<strong>FaceWash SENSI</strong> or a milky cleanser, <strong>Hyaluronic 7+ Serum</strong>, <strong>UltraIntense Moisturizer</strong>, and <strong>UltraMineral Glo SPF 50</strong> for hydration + sun protection in one.',
      ],
      [
        'Why is my skin still dry even with moisturizer?',
        "You're probably under-hydrating, not under-moisturizing. Layer a humectant serum (Hyaluronic 7+) on damp skin, then seal with a barrier cream. Dehydrated skin needs water, not just oil.",
      ],
      [
        'Can dry skin use actives?',
        'Yes, but pair with strong barrier support. Pre-treat with moisturizer if your skin is reactive - the so-called "sandwich method".',
      ],
    ],
    sunprotection: [
      [
        'Which sunscreen should I pick from the CodeSkin range?',
        '<strong>UltraProtect SPF 50+ PA++++</strong> for oily / acne-prone. <strong>UltraLite SPF 40+</strong> for everyday and sensitive skin. <strong>UltraMineral Glo SPF 50</strong> for dry, dull or pregnancy-safe routines.',
      ],
      [
        'How much sunscreen should I actually apply?',
        'Two finger-lengths for the face, equivalent to about ¼ teaspoon. Most Indians use a fraction of that - which is why SPF underperforms.',
      ],
      [
        'Do I need SPF indoors?',
        'Yes - windows let in UVA, which is the ageing wavelength. If you sit near a window or screen for hours, daily SPF is still warranted.',
      ],
      [
        "What's PA++++ and why does it matter in India?",
        'PA grades UVA protection (PA+ to PA++++). For Indian sun and pigmentation-prone skin, you want PA++++ - the highest grade - in your daily SPF.',
      ],
    ],
  };

  var FILTER_INTRO = {
    all: [
      'Buying guide · FAQ',
      'How to pick your CodeSkin routine.',
      'Start with cleanser + sunscreen - the two non-negotiables. Then layer one serum for your top concern and a moisturizer for your skin type. Below are the questions our Mumbai team gets asked most often.',
    ],
    sunscreen: [
      'Sunscreen · Buying guide',
      'Choosing the right SPF for Indian skin.',
      "All eight CodeSkin sunscreens are SPF 40+ broad-spectrum, dermatologist-tested and built for Indian climate. Below - the questions we hear most when someone's switching brands.",
    ],
    facewash: [
      'Face Wash · Buying guide',
      'Find the right cleanser for your skin.',
      'From acid-based brightening to acne-control and barrier-safe cleansers - pick one for AM and one (or the same one) for PM. Our most-asked questions are below.',
    ],
    serum: [
      'Serum · Buying guide',
      'Pick one serum, layer smart.',
      "One or two actives is usually enough. Start with a hydrating base, add a targeted serum for your top concern, and don't stack acids on the same night.",
    ],
    moisturizer: [
      'Moisturizer · Buying guide',
      'Hydration that fits your climate.',
      'Oily skin: gel-light. Combination: lotion. Dry / compromised: cream or barrier-repair. Match the texture to the climate you live in, not the season on the calendar.',
    ],
    'pre-cleanser': [
      'Pre Cleanser · Buying guide',
      "The first step you've been skipping.",
      'If you wear sunscreen daily, a pre-cleanser at night fully resets the skin so your active serums actually penetrate.',
    ],
    targeted: [
      'Targeted Treatments · Buying guide',
      "Spot-treat what your routine doesn't.",
      'Concentrated formulas for specific concerns - acne marks, melasma patches, redness or fine lines. Use sparingly and consistently.',
    ],
    acne: [
      'Acne & Breakouts · FAQ',
      'Calm active acne, fade the marks.',
      'The CodeSkin acne protocol is built around CLARIFI / OILY cleansers, niacinamide-rich serums and a non-comedogenic SPF 50+. Most users see calmer skin in 3-4 weeks.',
    ],
    sensitivity: [
      'Sensitivity & Redness · FAQ',
      'Less is more for reactive skin.',
      'Strip back to fragrance-free essentials and rebuild slowly. Mineral SPF, hydrating serums and barrier cream form the core - actives are layered in cautiously.',
    ],
    pigmentation: [
      'Pigmentation · FAQ',
      'Even tone, the science-backed way.',
      'Pigmentation is a long game - 8 to 16 weeks of consistent SPF, antioxidant and brightening actives. CodeSkin combines tranexamic acid, niacinamide and cysteamine in one daily serum.',
    ],
    darkspots: [
      'Dark Spots & Melasma · FAQ',
      'Fade marks without the bounce-back.',
      "Daily SPF 50+ is non-negotiable - it's what holds your results. The DarkSpot serum is built specifically for melasma and persistent PIH common to Indian skin.",
    ],
    antiageing: [
      'Anti-Ageing · FAQ',
      'Lines, elasticity, firmness - fixed gently.',
      "CodeSkin's anti-ageing routine is built on peptides + retinoids, layered with antioxidants and SPF. Start with peptides, graduate to retinoids when your skin is ready.",
    ],
    dryness: [
      'Dryness · FAQ',
      'Hydrate first, moisturize second.',
      'Dry skin usually needs more water, not more oil. Hyaluronic 7+ on damp skin sealed with UltraIntense Moisturizer is the CodeSkin standard for chronic dryness.',
    ],
    sunprotection: [
      'Sun Protection · FAQ',
      'India-grade SPF, every single day.',
      'UVA in Indian sun causes pigmentation, melasma and premature ageing. Daily SPF 50+ PA++++ is the single highest-ROI skincare habit you can build.',
    ],
  };

  function getUrls() {
    var cfg = window.codeskinCollectionGuideConfig;
    return (cfg && cfg.urls) || {};
  }

  function normalizeGuideKey(key) {
    if (!key) return 'all';
    if (key === 'sensitive') return 'sensitivity';
    if (key === 'anti-aging') return 'antiageing';
    if (key === 'melasma') return 'darkspots';
    if (key === 'sun-protection') return 'sunprotection';
    return key;
  }

  function resolveGuideLinks(container) {
    var urls = getUrls();
    container.querySelectorAll('[data-codeskin-guide-link]').forEach(function (link) {
      var key = link.getAttribute('data-codeskin-guide-link');
      if (urls[key]) link.setAttribute('href', urls[key]);
    });
  }

  function renderFAQ(root, key, label) {
    var guide = root.querySelector('[data-codeskin-guide]');
    if (!guide) return;

    key = normalizeGuideKey(key);
    var set = FAQ[key] || FAQ.all;
    var intro = FILTER_INTRO[key] || FILTER_INTRO.all;
    var eyebrowEl = guide.querySelector('#guide-eyebrow');
    var headingEl = guide.querySelector('#guide-heading');
    var introEl = guide.querySelector('#guide-intro');
    var filterPill = guide.querySelector('#guide-filter');
    var filterLabel = guide.querySelector('#guide-filter-label');
    var faqContainer = guide.querySelector('[data-codeskin-guide-faq]');

    if (!faqContainer) return;

    eyebrowEl.textContent = intro[0];
    headingEl.textContent = intro[1];
    introEl.textContent = intro[2];

    if (key === 'all') {
      filterPill.hidden = true;
    } else {
      filterPill.hidden = false;
      if (filterLabel) filterLabel.textContent = label || key;
    }

    faqContainer.innerHTML = set
      .map(function (pair, index) {
        return (
          '<div class="codeskin-faq-item" data-faq-index="' +
          index +
          '">' +
          '<button type="button" class="codeskin-faq-q" aria-expanded="false">' +
          '<span class="codeskin-faq-q-text">' +
          pair[0] +
          '</span>' +
          '</button>' +
          '<div class="codeskin-faq-answer" hidden>' +
          pair[1] +
          '</div></div>'
        );
      })
      .join('');

    resolveGuideLinks(guide);
    bindFaqInteractions(faqContainer);
  }

  function bindFaqInteractions(faqContainer) {
    if (!faqContainer || faqContainer.dataset.faqBound === 'true') return;
    faqContainer.dataset.faqBound = 'true';

    faqContainer.addEventListener('click', function (event) {
      var placeholderLink = event.target.closest('a[href="#"]');
      if (placeholderLink) {
        event.preventDefault();
      }
    });

    faqContainer.addEventListener('click', function (event) {
      var toggle = event.target.closest('.codeskin-faq-q');
      if (!toggle) return;

      var item = toggle.closest('.codeskin-faq-item');
      if (!item) return;

      var answer = item.querySelector('.codeskin-faq-answer');
      var isOpen = item.classList.contains('is-open');

      faqContainer.querySelectorAll('.codeskin-faq-item.is-open').forEach(function (openItem) {
        if (openItem === item) return;
        openItem.classList.remove('is-open');
        var openBtn = openItem.querySelector('.codeskin-faq-q');
        var openAns = openItem.querySelector('.codeskin-faq-answer');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        if (openAns) openAns.hidden = true;
      });

      if (isOpen) {
        item.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (answer) answer.hidden = true;
      } else {
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        if (answer) answer.hidden = false;
      }
    });
  }

  function setNavLinkActive(link, on) {
    if (!link) return;
    var li = link.closest('li');
    if (on) {
      if (li) {
        li.classList.add('active');
        li.classList.add('is-active');
      }
      link.classList.add('is-active');
      link.setAttribute('aria-current', 'page');
    } else {
      if (li) {
        li.classList.remove('active');
        li.classList.remove('is-active');
      }
      link.classList.remove('is-active');
      link.removeAttribute('aria-current');
    }
  }

  function syncCategoryNavHighlights(root, activeLink) {
    var activeFilter = activeLink ? activeLink.getAttribute('data-filter') : null;
    root.querySelectorAll('[data-codeskin-cat-nav]').forEach(function (link) {
      var isActive = !!activeFilter && link.getAttribute('data-filter') === activeFilter;
      setNavLinkActive(link, isActive);
    });
  }

  function syncConcernNavHighlights(root, activeLink) {
    var activeFilter = activeLink ? activeLink.getAttribute('data-filter') : null;
    root.querySelectorAll('[data-codeskin-concern-link]').forEach(function (link) {
      var isActive = !!activeFilter && link.getAttribute('data-filter') === activeFilter;
      setNavLinkActive(link, isActive);
    });
  }

  function pathFromHref(href) {
    if (!href || href === '#') return '';
    try {
      if (href.indexOf('http') === 0 || href.indexOf('//') === 0) {
        return new URL(href, window.location.origin).pathname.replace(/\/$/, '') || '/';
      }
    } catch (e) {}
    return href.split('?')[0].replace(/\/$/, '') || '/';
  }

  function syncNavHighlightFromUrl(root) {
    var path = window.location.pathname.replace(/\/$/, '') || '/';

    var catLinks = root.querySelectorAll('.col-cat-list [data-codeskin-cat-nav]');
    for (var i = 0; i < catLinks.length; i++) {
      var catLink = catLinks[i];
      if (pathFromHref(catLink.getAttribute('href')) === path) {
        applyGuideFilter(root, catLink);
        return true;
      }
    }

    var concernLinks = root.querySelectorAll('.col-tag-list [data-codeskin-concern-link]');
    for (var j = 0; j < concernLinks.length; j++) {
      var concernLink = concernLinks[j];
      if (pathFromHref(concernLink.getAttribute('href')) === path) {
        applyGuideFilter(root, concernLink);
        return true;
      }
    }

    return false;
  }

  function applyGuideFilter(root, link) {
    if (!link) return;
    var key = normalizeGuideKey(link.getAttribute('data-filter'));
    var type = link.getAttribute('data-filter-type');
    var label = link.getAttribute('data-filter-label') || link.textContent.trim();

    if (type === 'category') {
      syncCategoryNavHighlights(root, link);
      syncConcernNavHighlights(root, null);
    } else if (type === 'concern') {
      syncConcernNavHighlights(root, link);
      var allCatLink = root.querySelector('.col-cat-list [data-filter="all"][data-filter-type="category"]');
      syncCategoryNavHighlights(root, allCatLink || null);
    }

    renderFAQ(root, key, label);
  }

  function syncGuideFromActiveNav(root) {
    var activeConcern = root.querySelector('.col-tag-list li.active [data-filter][data-filter-type="concern"]');
    if (activeConcern) {
      applyGuideFilter(root, activeConcern);
      return;
    }
    var activeCat = root.querySelector('.col-cat-list li.active [data-filter][data-filter-type="category"]');
    if (activeCat && activeCat.getAttribute('data-filter') !== 'all') {
      applyGuideFilter(root, activeCat);
      return;
    }
    renderFAQ(root, 'all');
  }

  window.codeskinCollectionGuideApply = function (root, link) {
    applyGuideFilter(root, link);
  };

  window.initCodeskinCollectionGuide = function (root) {
    if (!root) return;

    var guide = root.querySelector('[data-codeskin-guide]');
    if (!guide || guide.dataset.guideBound === 'true') return;
    guide.dataset.guideBound = 'true';

    var clearBtn = guide.querySelector('#guide-filter-clear');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        var allLink = root.querySelector('[data-filter="all"][data-filter-type="category"]');
        if (allLink) applyGuideFilter(root, allLink);
        else renderFAQ(root, 'all');
      });
    }

    root.querySelectorAll('[data-filter][data-codeskin-guide-filter]').forEach(function (link) {
      link.addEventListener('click', function () {
        window.setTimeout(function () {
          syncGuideFromActiveNav(root);
        }, 50);
      });
    });

    var guideEl = root.querySelector('[data-codeskin-guide]');
    var initialKey = guideEl && guideEl.getAttribute('data-initial-guide-key');
    var initialLabel = guideEl && guideEl.getAttribute('data-initial-guide-label');
    var initialType = guideEl && guideEl.getAttribute('data-initial-guide-type');
    var applied = false;

    var serverActiveConcern = root.querySelector('.col-tag-list li.active [data-codeskin-concern-link]');
    var serverActiveCat = root.querySelector('.col-cat-list li.active [data-codeskin-cat-nav]');
    if (serverActiveConcern) {
      applyGuideFilter(root, serverActiveConcern);
      applied = true;
    } else if (serverActiveCat) {
      applyGuideFilter(root, serverActiveCat);
      applied = true;
    }

    if (!applied && initialKey && initialKey !== 'all') {
      var initialSelector =
        '[data-filter="' + initialKey + '"][data-filter-type="' + (initialType || 'category') + '"]';
      var initialLink = root.querySelector(initialSelector);
      if (initialLink) {
        applyGuideFilter(root, initialLink);
        applied = true;
      } else {
        renderFAQ(root, initialKey, initialLabel);
        applied = true;
      }
    }

    if (!applied) {
      var params = new URLSearchParams(window.location.search);
      var catKey = params.get('category');
      var target = catKey
        ? '[data-filter="' + catKey + '"][data-filter-type="category"]'
        : null;
      if (target) {
        var deepLink = root.querySelector(target);
        if (deepLink) {
          applyGuideFilter(root, deepLink);
          applied = true;
        }
      }
    }

    if (!applied) {
      if (!syncNavHighlightFromUrl(root)) {
        syncGuideFromActiveNav(root);
      }
    }

    var faq = root.querySelector('[data-codeskin-guide-faq]');
    if (faq && !faq.children.length) {
      renderFAQ(root, 'all');
    }
  };

  function bootAllCollectionGuides() {
    document.querySelectorAll('.codeskin-shop-collection').forEach(function (root) {
      if (root.querySelector('[data-codeskin-guide]')) {
        window.initCodeskinCollectionGuide(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAllCollectionGuides);
  } else {
    bootAllCollectionGuides();
  }
})();
